<template>
  <modal
    :visible.sync="dialogVisible"
    :title="title"
    :close-on-click-outside-or-escape="closeOnClickOutsideOrEscape"
    :show-close="showClose"
    :width="width"
    @close="handleClose"
  >
    <slot></slot>
    <template #footer>
      <div class="footer-buttons">
        <el-button
          v-if="leftButton.show"
          class="btn left-btn"
          @click="handleLeftButtonClick"
        >
          {{ leftButton.text }}
        </el-button>
        <el-button
          v-if="rightButton.show"
          class="btn right-btn"
          @click="handleRightButtonClick"
        >
          {{ rightButton.text }}
        </el-button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "./Modal.vue";

export default {
  name: "ConfirmModal",
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    closeOnClickOutsideOrEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    leftButton: {
      type: Object,
      default: () => ({
        show: true,
        text: "",
        closeOnClick: true,
        onClick: () => {}
      })
    },
    rightButton: {
      type: Object,
      default: () => ({
        show: true,
        text: "",
        onClick: () => {}
      })
    },
    width: {
      type: String,
      default: "400px"
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleLeftButtonClick() {
      if (this.leftButton.closeOnClick) {
        this.handleClose();
      }
      if (this.leftButton.onClick) {
        this.leftButton.onClick();
      }
    },
    handleRightButtonClick() {
      this.rightButton.onClick();
    }
  }
};
</script>

<style scoped lang="sass">
.footer-buttons
  display: flex;
  justify-content: space-between;
  margin-top: 2px;

.footer-buttons > :only-child:not(.left-btn)
  margin-left: auto !important;

.btn
  border-radius: 10px !important;
  background-color: #295661 !important;
  border: 2px solid #295661 !important;
  color: #fff !important;
  min-width: 120px;

  &:hover
    opacity: 0.9;
    box-shadow: 0 2px 8px rgba(41, 86, 97, 0.2);

.left-btn
  background-color: transparent !important;
  border: 2px solid #295661 !important;
  color: #295661 !important;

  &:hover
    background-color: #295661 !important;
    color: #fff !important;

.right-btn
  background-color: #295661 !important;
  border: 2px solid #295661 !important;
  color: #fff !important;

  &:hover
    background-color: #16353d !important;
    border-color: #16353d !important;

::v-deep .el-dialog__footer
  height: auto;
  min-height: 0;
  padding: 8px 20px 16px;
  box-sizing: border-box;
</style>
